import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AngularFirestore} from 'angularfire2/firestore';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class FirebaseNotesService {

  constructor(private afs: AngularFirestore) {
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @returns {Observable<any>}
   */
  getNoteByItemID(org_id: string, property_id: string, item_id: string): Observable<any> {
    const noteRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('notes').doc(item_id);
    return noteRef.snapshotChanges();
  }


  /**
   * Update a note By ItemID
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} item_id
   * @param formValue
   * @returns {Observable<any>}
   */
  updateNoteByItemID(org_id: string, property_id: string, item_id: string, formValue: any): Observable<any> {
    const updateNoteRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('notes').doc(item_id);

    const transaction = updateNoteRef.set({
      content: formValue.content
    });

    return this.fromFirebaseAuthPromise(transaction);

  }



  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @returns {Observable<any>}
   */
  deleteNoteByItemID(org_id: string, property_id: string, item_id: string): Observable<any> {
    const noteRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('notes').doc(item_id);
    return  this.fromFirebaseAuthPromise(noteRef.delete());
  }



  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/notes.service.ts